import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'

import ArcoVue from '@arco-design/web-vue';
import '@arco-design/web-vue/dist/arco.css';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';

// 导入全局消息组件
import { ZlMessagePlugin } from './utils/message'
// 导入全局模态框组件
import { ZlModalPlugin } from './utils/modal'
// 导入全局抽屉组件
import { ZlDrawerPlugin } from './utils/drawer'

import './permission'

const app = createApp(App);
app.use(ArcoVue);
app.use(ArcoVueIcon);

// 注册全局消息插件
app.use(ZlMessagePlugin);
// 注册全局模态框插件
app.use(ZlModalPlugin);
// 注册全局抽屉插件
app.use(ZlDrawerPlugin);

app.use(router);
app.use(pinia);

app.mount('#app')
